import { Controller } from '@hotwired/stimulus'

// Remembers the current (filtered/paginated) list URL so a record's
// "back to list" link can return exactly where the user was. Firing on any
// click inside the table is harmless — it only stores the URL — so plain
// cells stay selectable/copyable and only real links navigate.
// Paired with back_link_controller.
export default class extends Controller {
  remember() {
    sessionStorage.setItem(`backUrl:${window.location.pathname}`, window.location.href)
  }
}
